import { DigitalAssetsService } from './digital-assets.service';

export default angular
  .module('sfMobile.services.digital-assets', [])
  .service('digitalAssetsService', DigitalAssetsService).name;
